import { Wrap } from "@chakra-ui/react"
import React from "reactn"
import { StockistCard } from "./stockist-card"

export function StockistListing({ stockists = [] }) {
  return (
    <Wrap marginTop={5} spacing='40px' justify='center' id="StockistListing" >
      {stockists.map((s, index) => (
          <StockistCard stockist={s} key={s.id} eager={index === 0} />
      ))}
      </Wrap>

  )
}
